export const { NODE_ENV: environment } = process.env;

export const LINEUP_LIMIT = 16;
